import { render, staticRenderFns } from "./CaseTemplateOverview.vue?vue&type=template&id=d0c990c8"
import script from "./CaseTemplateOverview.vue?vue&type=script&lang=js"
export * from "./CaseTemplateOverview.vue?vue&type=script&lang=js"
import style0 from "./CaseTemplateOverview.vue?vue&type=style&index=0&id=d0c990c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports